"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiFormHelperTextOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            marginTop: spacing(1),
        },
        contained: {
            marginLeft: undefined,
            marginRight: undefined,
        },
    });
};
//# sourceMappingURL=MuiFormHelperText.js.map